// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

sortSelectStyles.select = {
    labelProps: {
        css: css`
            width: unset;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 22px;
            padding: 3px 8px 0 0;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            flex-grow: 1;
            &&&& select {
                ${xScreen("lte", "1024")} {
                    height: 34px;
                }
            }
        `,
    },
    sizeVariant: "small",
};
